import { useQueryParams } from "lib/hooks/useQueryParams";
import { useGetPreferences } from "pages/preferences/api/useGetPreferences";
import { PUB_LANG } from "redux/slices/api/initialisePreferences";
import { getFeaturedDates } from "./urlHelpers";
import { getFeaturedReportFilters, getTermFilters } from "./useGetFilters";

export const useCreateFeaturedSearchRequest = () => {
  const qs = useQueryParams();

  const pubLangPref = useGetPreferences(PUB_LANG);

  const getLanguageFilter = (termFilters) => {
    if (termFilters.language) return { language: termFilters.language };
    return {};
  };

  try {
    const featuredFilters = getFeaturedReportFilters();
    const termFilters = getTermFilters(qs, pubLangPref);
    const langFilter = getLanguageFilter(termFilters);
    const request = {
      filters: { ...featuredFilters, ...langFilter },
      dates: getFeaturedDates(),
      size: 3,
      restFilters: { ...termFilters },
    };

    return request;
  } catch (err) {
    console.error("Error creating featured search request:", err);
    return {};
  }
};
